import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import programaPdf from "../../../../Pdf/programaPdf";
import checklistCalidadPdf from "../../../../Pdf/checklistCalidadPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfPrograma extends Component {
  state = { loading: false };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.cargarPdf();
    }
  }

  cargarPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "programa/datosPdfPrograma",
        { programaId: this.props.programaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
        
        const data = res.data.data;
        const isChecklist = this.props.tipo === "checklist";
        const dd = isChecklist
          ? checklistCalidadPdf({ programa: data, procesos: data.procesos, empresa: data.empresa })
          : programaPdf({ programa: data, procesos: data.procesos, empresa: data.empresa, camposCalidad: this.props.camposCalidad });

          const frameId = this.props.tipo === "checklist" ? "checklistPdfFrame" : "programaPdfFrame";
          pdfMake.createPdf(dd).open({}, window.frames[frameId]);
        } else {
          message.warning("No se pudo cargar el programa");
          this.props.onCancel();
        }
      })
      .catch((err) => {
        console.error("❌ error catch:", err);
        message.error("Error de conexión");
        this.props.onCancel();
      })
      .finally(() => this.setState({ loading: false }));
  }

  descargar() {
    this.setState({ loading: true });
    axios
      .post(
        "programa/datosPdfPrograma",
        { programaId: this.props.programaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const data = res.data.data;
          const isChecklist = this.props.tipo === "checklist";
          const dd = isChecklist
            ? checklistCalidadPdf({ programa: data, procesos: data.procesos, empresa: data.empresa })
            : programaPdf({ programa: data, procesos: data.procesos, empresa: data.empresa, camposCalidad: this.props.camposCalidad });
          const fileName = isChecklist
            ? `Checklist - ${data.nombre}.pdf`
            : `Programa - ${data.nombre}.pdf`;
          pdfMake.createPdf(dd).download(fileName);
        } else {
          message.warning("No se pudo generar el PDF");
        }
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const { visible, onCancel } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title={this.props.tipo === "checklist" ? "Checklist de Calidad" : "Vista previa del Programa"}
        visible={visible}
        spinning={loading}
        onCancel={onCancel}
        paddingTop
        width={900}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 12 }}>
          <ButtonItem blanco loading={loading} onClick={this.descargar.bind(this)}>
            Descargar PDF
          </ButtonItem>
          <ButtonItem danger onClick={onCancel}>
            Cerrar
          </ButtonItem>
        </div>
        {(() => {
          const frameId = this.props.tipo === "checklist" ? "checklistPdfFrame" : "programaPdfFrame";
          return (
            <iframe
              title={this.props.tipo === "checklist" ? "Checklist PDF" : "Programa PDF"}
              id={frameId}
              name={frameId}
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          );
        })()}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  camposCalidad: state.empresa.camposCalidad,
});

export default connect(mapStateToProps)(ModalPdfPrograma);